export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/notesbg.7a1686b6.svg","height":170,"width":362,"blurWidth":0,"blurHeight":0};